export default function siteNotification() {
  const notification = document.querySelector('.notificationBanner--closeable');

  // Make sure we have a notice
  if (!notification) return;

  const closeBtn = document.querySelector('.notificationBanner--closeable i');
  const notificationId = closeBtn.dataset.closeNotification;
  const notificationStorage = JSON.parse(sessionStorage.getItem('notifications-closed'));

  let idList = [];
  idList.push(notificationId);

  if (notificationStorage) {
    idList = idList.concat(notificationStorage);
  }

  closeBtn.addEventListener('click', () => {
    notification.classList.remove('is-visible');
    sessionStorage.setItem('notifications-closed', JSON.stringify(idList));
  });
}
